// src/hooks/useBackButtonHandler.js
import { useEffect } from 'react';
import { App as CapApp } from '@capacitor/app';

const useBackButtonHandler = (location, navigate) => {
    useEffect(() => {
        const handler = () => {
            if (location.pathname !== '/') {
                navigate('/');
            } else {
                CapApp.exitApp();
            }
        };

        CapApp.addListener('backButton', handler);

        return () => {
            CapApp.removeAllListeners('backButton');
        };
    }, [location, navigate]);
};

export default useBackButtonHandler;
